<template>
	<div>
	<buttonlist @help="help" ref="SetBtn"></buttonlist>
		<div v-if="userData.Login_DB == 'WGZC'">
			<el-card class="box-card" >
				<div style="display: flex;background: white">
					<div style="width: 50%;text-align: left;display: flex">
						<el-link class="el-button--mini" type="primary" href="/excel/发货计划10-30.xlsx" download="发货计划10-30.xlsx" v-if="$processdata.getLang() != 2">{{$t('getapi[6111]')}}</el-link>
						<el-link class="el-button--mini" type="primary" href="/excel/发货计划10-30.xlsx" download="Delivery Plan10-30.xlsx" v-if="$processdata.getLang() == 2">{{$t('getapi[6111]')}}</el-link>
						<el-upload
								class="upload-demo"
								ref="upload"
								:action="uploadurlWG"
								:on-preview="handlePreview"
								:on-remove="handleRemove"
								:on-change="handleChange"
								:on-success="handleSuccess"
								:on-error="handleError"
								:file-list="fileList"
								:limit="1"
								style="margin-left: 8px"
						>
							<el-button slot="trigger" size="mini" type="primary" :disabled="!btn.Import">{{$t('getapi[372]')}}</el-button>
						</el-upload>
						<el-date-picker v-model="starttime" type="datetime" size="mini" style="width:200px;margin-left: 8px"></el-date-picker>
					</div>
					<div style="width: 50%;text-align: right;">
						<el-button type="primary" size="mini" @click="calc" :disabled="datajson.length == 0" style="margin-left: 8px">{{$t('getapi[2530]')}}</el-button>
						<el-button type="primary" size="mini" @click="expt">{{$t('getapi[922]')}}</el-button>
					</div>
				</div>
			</el-card>
			<el-tabs v-model="activeView1" :tab-position="'top'" type="" style="margin-top: 0px" @tab-click="selectInfo">
				<el-tab-pane :label="$t('getapi[7094]')" name="0">
					<div style="padding: 2px"><el-button type="primary" size="mini" @click="deleteAll" :disabled="selectData.length == 0">{{$t('getapi[4411]')}}</el-button></div>
					<div  id="xpane-30">
						<vxe-table :data="datajson" size="mini"
								   :loading="loading"
								   header-cell-class-name="headerclass"
								   :height="tableHeight"
								   @checkbox-change="handleSelectionChangeWG"
								   @checkbox-all="handleSelectionChangeAllWG"
								   :row-class-name="tableRowClassNameDetail"
								   stripe
								   border
								   resizable
								   :auto-resize="true">
							<vxe-table-column type="checkbox" align="center" width="40px"></vxe-table-column>
							<vxe-table-column  show-footer-overflow v-for="item in returnArray"
											   :key="item.Headen"
											   :field="item.Headen"
											   :title="item.Headcn"
											   width="130px"
											   sortable
							></vxe-table-column>
						</vxe-table>
					</div>
				</el-tab-pane>
				<el-tab-pane :label="$t('getapi[13323]')" name="1" id="xpane-31">
					<vxe-table :data="datajsonA" size="mini" :loading="loading" header-cell-class-name="headerclass" :height="tableHeight" stripe border resizable :auto-resize="true">
						<vxe-table-column  show-footer-overflow v-for="item in returnArrayA"
										   :key="item.ColumnsField"
										   :field="item.ColumnsField"
										   :title="item.ColumnsName"
										   :align="item.ColumnsName=='补发数'?'right':'left'"
										   width="150px"
										   sortable
						></vxe-table-column>
					</vxe-table>
				</el-tab-pane>
			</el-tabs>
		</div >
		<div v-if="userData.Login_DB != 'WGZC'">
			<el-card class="box-card">
				<div style="display: flex;background: white">
					<div style="width: 50%;text-align: left;display: flex" v-if="pagetype == 10">
						<el-link class="el-button--mini" type="primary" href="/excel/发货计划10-30.xlsx" download="发货计划10-30.xlsx" v-if="$processdata.getLang() != 2">{{$t('getapi[6111]')}}</el-link>
						<el-link class="el-button--mini" type="primary" href="/excel/发货计划10-30.xlsx" download="Delivery Plan10-30.xlsx" v-if="$processdata.getLang() == 2">{{$t('getapi[6111]')}}</el-link>
						<el-upload
								class="upload-demo"
								ref="upload"
								:action="uploadurl"
								:on-preview="handlePreview"
								:on-remove="handleRemove"
								:on-change="handleChange"
								:on-success="handleSuccess"
								:on-error="handleError"
								:file-list="fileList"
								:limit="1"
								style="margin-left: 8px"
						>
							<el-button slot="trigger" size="mini" type="primary" :disabled="!btn.Import">{{$t('getapi[372]')}}</el-button>
						</el-upload>
						<el-date-picker v-model="starttime" type="datetime" size="mini" style="width:200px;margin-left: 8px"></el-date-picker>
					</div>
					<div style="width: 50%;text-align: left;display: flex" v-if="pagetype != 10">
						<el-link class="el-button--mini" type="primary" href="/excel/点检模板.xlsx" download="点检模板.xlsx">{{$t('getapi[6111]')}}</el-link>
						<el-upload
								class="upload-demo"
								ref="upload"
								:action="uploadurl1"
								:on-preview="handlePreview1"
								:on-remove="handleRemove1"
								:on-change="handleChange1"
								:on-success="handleSuccess1"
								:on-error="handleError1"
								:file-list="fileList1"
								:limit="1"
								style="margin-left: 8px"
						>
							<el-button slot="trigger" size="mini" type="primary" :disabled="!btn.Import">{{$t('getapi[372]')}}</el-button>
						</el-upload>
					</div>
					<div style="width: 50%;text-align: right;">
						<el-button v-if="pagetype == 10" type="primary" size="mini" @click="check">{{$t('getapi[439]')}}</el-button>
						<span v-if="pagetype == 10" style="margin-left: 8px">{{$t('getapi[4209]')}}</span>
						<el-input v-if="pagetype == 10" style="width:100px" v-model="Schedule_No" size="mini"></el-input>
						<el-button v-if="pagetype == 10" type="primary" size="mini" @click="calc" :disabled="!ischeck" style="margin-left: 8px">{{$t('getapi[2530]')}}</el-button>
						<el-button v-if="pagetype == 20" type="primary" size="mini" @click="getoriginal">{{$t('getapi[439]')}}</el-button>
						<el-button v-if="pagetype == 20" type="primary" size="mini" @click="calcoriginal" :disabled="excelURLMerge == ''">{{$t('getapi[2530]')}}</el-button>
						<el-button type="primary" size="mini" @click="expt">{{$t('getapi[922]')}}</el-button>
						<el-button v-if="pagetype == 10" type="primary" size="mini" @click="schProShort(0)" :disabled="datajsonB.length < 1">{{$t('getapi[8187]')}}</el-button>
					</div>
				</div>
			</el-card>
			<el-tabs :tab-position="'top'" v-model="activePage" type="" style="margin-top: 0px" @tab-click="selectPage">
				<el-tab-pane :label="$t('getapi[6584]')" name="10">
					<el-tabs v-model="activeView1" :tab-position="'top'" type="" style="margin-top: 0px" @tab-click="selectInfo">
						<el-tab-pane :label="$t('getapi[7094]')" name="0">
							<div  id="xpane-0">
								<vxe-table :data="datajson" size="mini" :loading="loading" header-cell-class-name="headerclass" :height="tableHeight" stripe border resizable :auto-resize="true">
									<vxe-table-column  show-footer-overflow v-for="item in returnArray"
													   :key="item.Headen"
													   :field="item.Headen"
													   :title="item.Headcn"
													   width="130px"
													   sortable
									></vxe-table-column>
								</vxe-table>
							</div>
						</el-tab-pane>
						<el-tab-pane :label="$t('getapi[878]')" name="1" id="xpane-1">
							<vxe-table :data="datajsonA" size="mini" :loading="loading" header-cell-class-name="headerclass" :height="tableHeight" stripe border resizable :auto-resize="true">
								<vxe-table-column  show-footer-overflow v-for="item in returnArrayA"
												   :key="item.ColumnsField"
												   :field="item.ColumnsField"
												   :title="item.ColumnsName"
												   :align="item.ColumnsName=='补发数'?'right':'left'"
												   width="150px"
												   sortable
								></vxe-table-column>
							</vxe-table>
						</el-tab-pane>
						<el-tab-pane :label="$t('getapi[7095]')" name="2" id="xpane-2">
							<vxe-table
									@checkbox-change="handleSelectionChange"
									:data="datajsonB"  size="mini" :loading="loading"  :height="tableHeight" stripe border resizable :auto-resize="true">
								<vxe-table-column align="center" type="checkbox" width="40" v-if="false"></vxe-table-column>
								<vxe-table-column  show-footer-overflow v-for="item in returnArrayB"
												   :key="item.ColumnsField"
												   :field="item.ColumnsField"
												   :title="item.ColumnsName"
												   :align="item.ColumnsName=='完工数'||item.ColumnsName=='未入库数'||item.ColumnsName=='本次匹配数'?'right':'left'"
												   :width="changeWdith(item.ColumnsName)"
												   sortable
								>
									<template scope="scope">
								<span v-if="item.ColumnsField =='old_date'">
									{{scope.row.old_date | toDate}}
								</span>
										<span v-else>
									<span>{{scope.row[item.ColumnsField]}}</span>
								</span>
									</template>
								</vxe-table-column>
							</vxe-table>
							<div style="margin-top: 5px">
								<span>{{$t('getapi[6326]')}}:{{result}}</span>
							</div>
						</el-tab-pane>
					</el-tabs>
				</el-tab-pane>
				<el-tab-pane :label="$t('getapi[12977]')" name="20">
					<el-tabs v-model="activeView2" :tab-position="'top'" type="" style="margin-top: 0px" @tab-click="selectInfo">
						<el-tab-pane :label="$t('getapi[12978]')" name="21" id="xpane-21">
							<vxe-table :data="datajsonoriginal" size="mini" :loading="loading" header-cell-class-name="headerclass" :height="tableHeight" stripe border resizable :auto-resize="true">
								<vxe-table-column  show-footer-overflow v-for="item in returnArrayOriginal"
												   :key="item.ColumnsField"
												   :field="item.ColumnsField"
												   :title="item.ColumnsName"
												   :align="item.Headen=='plan_finish_qty'?'right':'left'"
												   width="150px"
												   sortable
								></vxe-table-column>
							</vxe-table>
						</el-tab-pane>
						<el-tab-pane :label="$t('getapi[12979]')" name="22" id="xpane-22">
							<vxe-table
									:data="datajsonmerge"  size="mini" :loading="loading"  :height="tableHeight" stripe border resizable :auto-resize="true">
								<vxe-table-column align="center" type="checkbox" width="40" v-if="false"></vxe-table-column>
								<vxe-table-column  show-footer-overflow v-for="item in returnArrayMerge"
												   :key="item.ColumnsField"
												   :field="item.ColumnsField"
												   :title="item.ColumnsName"
												   :align="item.ColumnsField=='qty_on_hand'||item.ColumnsField=='limit'?'right':'left'"
												   :width="changeWdith(item.ColumnsName)"
												   sortable
								>
								</vxe-table-column>
							</vxe-table>
						</el-tab-pane>
						<el-tab-pane :label="$t('getapi[878]')" name="23" id="xpane-23">
							<vxe-table :data="datajsonA_" size="mini" :loading="loading" header-cell-class-name="headerclass" :height="tableHeight" stripe border resizable :auto-resize="true">
								<vxe-table-column  show-footer-overflow v-for="item in returnArrayA_"
												   :key="item.ColumnsField"
												   :field="item.ColumnsField"
												   :title="item.ColumnsName"
												   :align="item.ColumnsName=='补发数'?'right':'left'"
												   width="150px"
												   sortable
								></vxe-table-column>
							</vxe-table>
						</el-tab-pane>
						<el-tab-pane :label="$t('getapi[7095]')" name="24" id="xpane-24">
							<vxe-table
									@checkbox-change="handleSelectionChange"
									:data="datajsonB_"  size="mini" :loading="loading"  :height="tableHeight" stripe border resizable :auto-resize="true">
								<vxe-table-column align="center" type="checkbox" width="40" v-if="false"></vxe-table-column>
								<vxe-table-column  show-footer-overflow v-for="item in returnArrayB_"
												   :key="item.ColumnsField"
												   :field="item.ColumnsField"
												   :title="item.ColumnsName"
												   :align="item.ColumnsName=='完工数'||item.ColumnsName=='未入库数'||item.ColumnsName=='本次匹配数'?'right':'left'"
												   :width="changeWdith(item.ColumnsName)"
												   sortable
								>
									<template scope="scope">
								<span v-if="item.ColumnsField =='old_date'">
									{{scope.row.old_date | toDate}}
								</span>
										<span v-else>
									<span>{{scope.row[item.ColumnsField]}}</span>
								</span>
									</template>
								</vxe-table-column>
							</vxe-table>
							<div style="margin-top: 5px">
								<span>{{$t('getapi[6326]')}}:{{result}}</span>
							</div>
						</el-tab-pane>
					</el-tabs>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
import CommonHeader from '@/components/CommonHeader';
export default {
	name:'2_lesscompute',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight - 210
        }
    },
	data() {
		return {
            userData:[],
			fileList: [],
            fileList1: [],
			ids: '',
			showloading: '',
			DbTbNames: '', //表名
			datajson: [],
			datajsonA: [],
			datajsonB: [],
			datajsonremark: [],
			datajsonliu: [],
			returnArray:[],
			returnArrayA:[],
			returnArrayB:[],
			loading: false, // 主表加载状态
			uploadurl: '',
            uploadurl1:'',
            uploadurlWG:'',//武滚库
			uploadurlremark: '',
			uploadurlliu: '',
			drolist: [],
			drolistliu: [],
			drosele: 0,
			droseleliu: 0,
			total1: 0,
			returnURL:'',
			excelURLA:'',
			excelURLB:'',
			selectIndex:'0',
			btn:{
				//导入
				Import:true,
                schproshort: false
			},
			selectData: [],
            getstatus: null,
            result: '',
            ischeck: false,//是否校验
            starttime: '',
            Schedule_No: '',// 计划单号
            activePage:'10',
            pagetype:'10',//10:缺料计算 20:点检
			//点检数据
            datajsonoriginal:[],
            datajsonmerge:[],
            returnArrayOriginal:[],
            returnArrayMerge:[],
            excelURLOriginal:'',
            excelURLMerge:'',
            activeView1:'0',
            activeView2:'21',
            datajsonA_: [],
            datajsonB_: [],
            returnArrayA_:[],
            returnArrayB_:[],
            excelURLA_:'',
            excelURLB_:'',
		};
	},
	create() {},
	beforeMount() {
		let that = this;
		that.userData = JSON.parse(sessionStorage.getItem('userData'));
		let token = that.userData.token;
		that.uploadurl = Common.Url + '/Pro/SO/ShortCalcImportUpFile?token=' + token + '&LangType='+that.$processdata.getLang();
        that.uploadurlWG = Common.Url + '/Pro/SO/ShortCalcImportUpFileWG?token=' + token + '&LangType='+that.$processdata.getLang();
        that.uploadurl1 = Common.Url + '/Pro/SO/ShortCalcSpotUpFile?token=' + token + '&LangType='+that.$processdata.getLang();
		this.btnauthority();
	},
    beforeDestroy(){
        clearInterval(this.getstatus)
        this.getstatus = null
    },
	mounted() {
		console.log('mounted');
		let that = this
        that.$nextTick(() => {
            addEventListener('paste', that.keyPaste);//创建键盘粘贴监听事件
        });
		this.authority()
		this.btnauthority();
	},
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6584]"),this.$t("getapi[25]"));
        },
        authority(){
            let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetButtonEnable('');
		},
		btnauthority() {
			let that = this;
			that.btn.schproshort = false
			console.log(that.selectData)
            if(that.selectData.length > 0){
                that.btn.schproshort = that.selectData.every(val => {
                    return val.diff == '自制件'
                });
            }

        },
        selectPage(tab, event){
            let that = this
			that.pagetype = tab.name
		},
		selectInfo(tab, event) {
			let that = this;
            that.selectIndex = tab.name;
			if(that.activePage == 10){
                that.activeView1 = tab.name
			} else {
                that.activeView2 = tab.name
			}
            that.$nextTick(function(){
                setTimeout(() => {
                    that.$processdata.initAllForm()
                }, 500);
            });
		},
		changeWdith(columnName){
			if(columnName=='行号')
			{
				return '50px';
			}else if(columnName=='修正时间'){
				return '120px';
			}
			else if(columnName=='物料版本'||columnName=='行号'||columnName=='本次匹配数'||columnName=='区分'||columnName=='直接流转'||columnName=='完工数'||columnName=='未入库数'){
				return '80px';
			}else{
				return '150px';
			}
		},
		expt(){
			let that = this;
				if(that.selectIndex=='0'){
					if(that.datajson.length>0){
						let hrefurl = Common.Url+that.returnURL;
						window.open(hrefurl);
					}else{
						this.$message.warning(that.$t('getapi[8757]'));//"暂无数据可导出!"
					}
				}else if(that.selectIndex=='1'){
				if(that.datajsonA.length>0){
				let hrefurl = Common.Url + that.excelURLA;
				window.open(hrefurl);
				}else{
				this.$message.warning(that.$t('getapi[8757]'));//"暂无数据可导出!"
				}
				}else if(that.selectIndex=='2'){
				if(that.datajsonB.length>0){
				let hrefurl = Common.Url + that.excelURLB;
				window.open(hrefurl);}else{
                    this.$message.warning(that.$t('getapi[8757]'));//"暂无数据可导出!"
                }
				} else if(that.selectIndex=='21'){
                    if(that.datajsonoriginal.length>0) {
                        let hrefurl = Common.Url + that.excelURLOriginal;
                        window.open(hrefurl);
                    }else{
                        this.$message.warning(that.$t('getapi[8757]'));//"暂无数据可导出!"
                    }
				}else if(that.selectIndex=='22'){
                        if(that.datajsonmerge.length>0) {
                            let hrefurl = Common.Url + that.excelURLMerge;
                            window.open(hrefurl);
                        }else{
                            this.$message.warning(that.$t('getapi[8757]'));//"暂无数据可导出!"
                        }
				}else if(that.selectIndex=='23'){
                    if(that.datajsonA_.length>0) {
                        let hrefurl = Common.Url + that.excelURLA_;
                        window.open(hrefurl);
                    }else{
                        this.$message.warning(that.$t('getapi[8757]'));//"暂无数据可导出!"
                    }
                }else if(that.selectIndex=='24'){
                    if(that.datajsonB_.length>0) {
                        let hrefurl = Common.Url + that.excelURLB_;
                        window.open(hrefurl);
                    }else{
                        this.$message.warning(that.$t('getapi[8757]'));//"暂无数据可导出!"
                    }
                }else{
					this.$message.warning(that.$t('getapi[8757]'));//"暂无数据可导出!"
				}
		},
		//校验1
		check(){
			let that = this;
			that.loading = true;
			if (that.datajson.length<= 0)
            {
                this.$message.warning(that.$t('getapi[8759]'));//"请首先添加原始数据！"
                return;
			}

			let data ={
			"MultyVer": 0,
			"iTemplate": '',
			"FilePath": that.returnURL,
                LangType: that.$processdata.getLang()
			};
			if(that.userData.Login_DB == 'WGZC'){
                let posturl = '/Pro/SO/ShortCalcCheckWG';
                that.$http.urlpost(posturl, data, function(res) {
                    if (res.Success == 1) {
                        that.ischeck = true
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    else{
                        that.datajson=res.DataContent.dt;
                        that.returnArray = res.DataContent.TbHeader;
                        that.returnURL = res.DataContent.URL;
                    }
                    that.loading = false;
                });
			} else {
                let posturl = '/Pro/SO/ShortCalcCheck';
                that.$http.urlpost(posturl, data, function(res) {
                    if (res.Success == 1) {
                        that.ischeck = true
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    else{
                        // console.log("信息:"+res.DataContent.dt);
                        that.datajson=res.DataContent.dt;
                        that.returnArray = res.DataContent.TbHeader;
                        that.returnURL = res.DataContent.URL;
                    }
                    that.loading = false;
                });
			}

		},
		//cal
		calc(){
			let that = this;
			if (that.datajson.length<= 0)
            {
                this.$message.warning(that.$t('getapi[8759]'));//"请首先添加原始数据！"
                return;
			}
			that.loading = true;

			if(that.userData.Login_DB == 'WGZC'){
			    let data = {
                    LangType: that.$processdata.getLang(),
                    ls:that.datajson
				}
                let posturl = '/Pro/SO/ShortCalcWG2';
                that.$http.urlpost(posturl, data, function(res) {
                    if (res.Success == 1) {
                        that.datajsonA = res.DataContent.DataListA;
                        that.returnArrayA = res.DataContent.ColumnsListA;
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.activeView1 = '1'
                    } else if (res.Success == 2){
                        that.datajson = res.DataContent.Data
					}
                    that.loading = false;
                });
			} else {
                let data ={
                    "MultyVer": 0,
                    "iTemplate": '',
                    Schedule_No:that.Schedule_No,
                    "FilePath": that.returnURL,
                    StartTime: that.starttime,
                    LangType: that.$processdata.getLang()
                };
                let posturl = '/Pro/SO/ShortCalc';
                that.$http.urlpost(posturl, data, function(res) {
                    if (res.Success == 1) {
                        that.datajsonA = res.DataContent.DataListA;
                        that.datajsonB = res.DataContent.DataListB;
                        for(let i=0;i<that.datajsonB.length;i++){
                            that.datajsonB[i].modify_time =that.$limits.getDateType(that.datajsonB[i].modify_time);
                        }
                        that.returnArrayA = res.DataContent.ColumnsListA;
                        that.returnArrayB = res.DataContent.ColumnsListB;
                        that.excelURLA = res.DataContent.URLA;
                        that.excelURLB = res.DataContent.URLB;
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    that.loading = false;
                });
			}

		},
		//点检的工单缺料计算
        getoriginal(){
            let that = this;
            that.loading = true;
            let data ={
                "MultyVer": 0,
                "iTemplate": '',
                "FilePath":that.excelURLOriginal,
                LangType: that.$processdata.getLang()
            };
            let posturl = '/Pro/SO/SpotCheckOriginal';
            that.$http.urlpost(posturl, data, function(res) {
                if (res.Success == 1) {
                    that.datajsonoriginal = res.DataContent.DataListOriginal;
                    that.datajsonmerge = res.DataContent.DataListMerge;
                    /*for(let i=0;i<that.datajsonB.length;i++){
                        that.datajsonB[i].modify_time =that.$limits.getDateType(that.datajsonB[i].modify_time);
                    }*/
                    that.returnArrayOriginal = res.DataContent.ColumnsListOriginal;
                    that.returnArrayMerge = res.DataContent.ColumnsListMerge;
                    that.excelURLOriginal = res.DataContent.URLOriginal;
                    that.excelURLMerge = res.DataContent.URLMerge;
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                } else if(res.Success == 2){
                    that.datajsonoriginal = res.DataContent.DataListOriginal;
                    that.datajsonmerge = res.DataContent.DataListMerge;
                    that.returnArrayOriginal = res.DataContent.ColumnsListOriginal;
                    that.returnArrayMerge = res.DataContent.ColumnsListMerge;
                    that.excelURLOriginal = res.DataContent.URLOriginal;
                    that.excelURLMerge = res.DataContent.URLMerge;
				}
                that.loading = false;
            });
		},
		calcoriginal(){
            let that = this;
            if (that.datajsonmerge.length<= 0)
            {
                this.$message.warning(that.$t('getapi[8759]'));//"请首先添加原始数据！"
                return;
            }
            that.loading = true;
            let data ={
                "MultyVer": 0,
                "iTemplate": '',
                Schedule_No:that.Schedule_No,
                "FilePath": that.excelURLMerge,
                StartTime: that.starttime,
                LangType: that.$processdata.getLang()
            };
            let posturl = '/Pro/SO/ShortCalc';
            that.$http.urlpost(posturl, data, function(res) {
                if (res.Success == 1) {
                    that.datajsonA_ = res.DataContent.DataListA;
                    that.datajsonB_ = res.DataContent.DataListB;
                    for(let i=0;i<that.datajsonB.length;i++){
                        that.datajsonB_[i].modify_time =that.$limits.getDateType(that.datajsonB_[i].modify_time);
                    }
                    that.returnArrayA_ = res.DataContent.ColumnsListA;
                    that.returnArrayB_ = res.DataContent.ColumnsListB;
                    that.excelURLA_ = res.DataContent.URLA;
                    that.excelURLB_ = res.DataContent.URLB;
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                }
                that.loading = false;
            });
		},
		//删除行
		delline(e) {
			console.log(e);
			let line = e.$rowIndex;
			if (line >= 0) {
				this.datajson.splice(line, 1);
			} else {
				this.$message.error(this.$t('getapi[8710]'));//'移除失败'
			}
		},
		dellines(e) {
			let line = e.$rowIndex;
			if (line >= 0) {
				this.datajsonremark.splice(line, 1);
			} else {
				this.$message.error(this.$t('getapi[8710]'));//'移除失败'
			}
		},
		dellineliu(e) {
			let line = e.$rowIndex;
			if (line >= 0) {
				this.datajsonliu.splice(line, 1);
			} else {
				this.$message.error(this.$t('getapi[8710]'));//'移除失败'
			}
		},
		handleSelectionChange({checked, records }) {
			let that = this;
			that.selectData = records;
			that.btnauthority()
		},
        // 缺料排产
        schProShort(val) {
            let that = this
            that.$confirm(that.$t('getapi[8597]'), that.$t('getapi[194]'), {//'执行排产可能要花费很长时间，确定要执行嘛'
                confirmButtonText: that.$t('getapi[1146]'),
                cancelButtonText: that.$t('getapi[2054]'),
                type: 'warning'
            })
                .then(() => {
                    let arr = []
                    for (let i = 0; i < that.datajsonB.length; i++) {
                        if(that.datajsonB[i].diff == '自制件'){
                            arr = [...arr, {
                                so_code: that.datajsonB[i].so_code,
                                part_code: that.datajsonB[i].part_code,
                                part_version: that.datajsonB[i].part_version,
                                plan_finish_date: that.datajsonB[i].modify_time,
                                plan_finish_qty: that.datajsonB[i].this_count,
                            }]
						}
                    }
                    let parm = {
                        ls: arr,
                        iscontinue: val
                    }
                    let iscontinue = true
                    that.$http.urlpost('/Pro/SO/ImplementSchProShort', parm, function (res) {
                        if (res.Success == 1) {
                           /* that.getstatus = setInterval(() => {
                                that.getStatus()
                            }, 1000);*/
                        } else if(res.Success == 3){
                            iscontinue = false
                            that.$message.warning(that.$processdata.explainCallbackMsg(res.Msg));
                        } else if(res.Success > 1 && res.Success != 3){
                            iscontinue = false
                            that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                                confirmButtonText: that.$t('getapi[1146]'),
                                cancelButtonText: that.$t('getapi[2054]'),
                                type: 'warning'
                            })
                                .then(() => {
                                    that.schProShort(res.Success)
                                })
                                .catch(() => {
                                    this.$message({
                                        type: 'info',
                                        message: that.$t('getapi[6096]')
                                    });
                                });
                        }
                    });
					setTimeout(() => {
						if(iscontinue){
							that.getStatus()
						}
					}, 10000);
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: that.$t('getapi[6096]')
                    });
                });

        },
        //获取最新状态
        getStatus(){
            let that = this
            let getPlanStatus = setInterval(() => {
                let parm = {
                    counted_old: 1
                }
                that.$http.urlpost('/Pro/SchPro/GetImplementSchProStatus', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent
                        that.result = that.dataDetail.result
                        if(that.dataDetail.status == 2){
                            that.visCalculated = true
                            clearInterval(getPlanStatus)
                            getPlanStatus = null
							that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        }
                    } else if(res.Success == 2){
                        that.dataDetail = res.DataContent
                        that.result = that.dataDetail.result
                    }
                });
            }, 5000);
        },
		handleChange(file, fileList) {
			let that = this;
			that.loading = true;
			console.log(file);
			if (file.response) {
				let response = file.response.Success;
				if (response == 0) {
					that.$message.error(that.$processdata.explainCallbackMsg(file.response.Msg));
				} else {
					that.datajson = file.response.DataContent.dt;
				}
				that.loading = false;
			}
		},
		handleSuccess(res, file, fileList) {
			let that = this;
			console.log(res);
			let response = res.Success;
			if (response == 0) {
				that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
			} else {
				//that.datajson = res.DataContent;
				that.returnArray = res.DataContent.TbHeader;
				that.returnURL = res.DataContent.URL;
				that.datajson = res.DataContent.dt;
				that.ischeck = false
			}
			that.fileList=[];
			that.loading = false;
            that.$nextTick(function () {
                setTimeout(() => {
                    that.$processdata.initAllForm()
                }, 500);
            })
		},
		handleError(err, file, fileList) {
			let that = this;
			that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
			that.loading = false;
		},
		handleChangeremark(file, fileList) {
			let that = this;
			console.log(file);
			if (file.response) {
				let response = file.response.Success;
				if (response == 0) {
					that.$message.error(that.$processdata.explainCallbackMsg(file.response.Msg));
				} else {
					that.datajsonremark = file.response.DataContent;
				}
			}
		},
		handleSuccessremark(res, file, fileList) {
			let that = this;
			console.log(res);
			let response = res.Success;
			if (response == 0) {
				that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
			} else {
				that.datajsonremark = res.DataContent;
			}
		},
		handleErrorremark(err, file, fileList) {
			let that = this;
			that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
		},
		handleChangeliu(file, fileList) {
			let that = this;
			console.log(file);
			if (file.response) {
				let response = file.response.Success;
				if (response == 0) {
					that.$message.error(that.$processdata.explainCallbackMsg(file.response.Msg));
				} else {
					that.datajsonliu = file.response.DataContent;
				}
			}
		},
		handleSuccessliu(res, file, fileList) {
			let that = this;
			console.log(res);
			let response = res.Success;
			if (response == 0) {
				that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
			} else {
				that.datajsonliu = res.DataContent;
			}
			that.fileList=[];
			
		},
		handleRemove(file, fileList) {
			console.log(file, fileList);
		},
		handlePreview(file) {
			console.log("handlePreview"+file);
		},
		// 保存数据
		okbtn() {
			let that = this;
			that.loading = true;
			let parm = {
				SaveType: that.drosele,
                LangType: that.$processdata.getLang(),
				List: []
			};
			parm.List = that.datajson;
			console.log(JSON.stringify(parm));
			that.$http.urlpost('Eng/Routings/RWHoursSave', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[818]'));
				}
				that.loading = false;
			});
		},
		// 保存备注数据
		okbtns() {
			let that = this;
			that.loading = true;
			let parm = that.datajsonremark;
			console.log(JSON.stringify(parm));
			that.$http.urlpost('Eng/Routings/RoutRemarkSave', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[818]'));
				}
				that.loading = false;
			});
		},
		// 保存流转方向数据
		okbtnliu() {
			let that = this;
			if(that.droseleliu==4){
				that.loading = true;
				let parm = that.datajsonliu;
				console.log(JSON.stringify(parm));
				that.$http.urlpost('Eng/Routings/RoutRemarkSave', parm, function(res) {
				if (res.Success == 1) {
				that.$message.success(that.$t('getapi[818]'));
				}
				that.loading = false;
				});
			}else if(that.droseleliu==3){
				that.loading = true;
				let parm = {
				SaveType: that.droseleliu,
				List: []
				};
				parm.List = that.datajsonliu;
				console.log(JSON.stringify(parm));
				that.$http.urlpost('Eng/Routings/RoutMoveSave', parm, function(res) {
				if (res.Success == 1) {
				that.$message.success(that.$t('getapi[818]'));
				}
				that.loading = false;
				});
			}else{

				that.$message.warning(that.$t('getapi[8625]'));//'请选择更新字段'
			}
		},
		//点检浏览文件
        handleChange1(file, fileList) {
            let that = this;
            that.loading = true;
            if (file.response) {
                let response = file.response.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(file.response.Msg));
                } else {
                    that.datajsonoriginal = file.response.DataContent.DataList;
                }
                that.loading = false;
            }
        },
        handleSuccess1(res, file, fileList) {
            let that = this;
            console.log(res);
            let response = res.Success;
            if (response == 0) {
                that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
            } else {
                that.datajsonoriginal = res.DataContent.DataList;
                that.returnArrayOriginal = res.DataContent.ColumnsList;
                that.excelURLOriginal = res.DataContent.URL;
            }
            that.fileList1=[];
            that.loading = false;
            that.$nextTick(function () {
                setTimeout(() => {
                    that.$processdata.initAllForm()
                }, 500);
            })
        },
        handleError1(err, file, fileList) {
            let that = this;
            that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            that.loading = false;
        },
        handleRemove1(file, fileList) {
            console.log(file, fileList);
        },
        handlePreview1(file) {
            console.log("handlePreview"+file);
        },
		//武滚-基础数据删除
        handleSelectionChangeWG({ checked,records }) {
            let that = this;
            that.selectData = records
        },
        handleSelectionChangeAllWG({ records }){
            let that = this
            this.selectData = records;
        },
        tableRowClassNameDetail({ row, rowIndex }) {
            row.index = rowIndex;
        },
		deleteAll(){
            let that = this
            for (let i = that.selectData.length - 1; i >= 0; i--) {
                that.datajson.splice(that.selectData[i].index, 1);
            }
		},
        // 粘贴
        keyPaste(e) {
            let that = this;
            if ((this.$route.name == this.$options.name) && (that.userData.Login_DB == 'WGZC') && (that.activeView1 == 0)) {
                if (e.clipboardData) {
                    var data = e.clipboardData.getData('Text');
                    if (!that.$limits.fnIsEmpty(data)) {
                        that.copycheck(data);
                    }
                }
            }
        },
        copycheck(datap) {
            let that = this
            that.returnArray =  [
                {
                    "Headen": "part_code",
                    "Headcn": "物料编码",
                    "IsNotNull": false,
                    "align": null
                },
                {
                    "Headen": "part_version",
                    "Headcn": "版本",
                    "IsNotNull": false,
                    "align": null
                },
                {
                    "Headen": "qty",
                    "Headcn": "数量",
                    "IsNotNull": false,
                    "align": null
                },
                {
                    "Headen": "remark",
                    "Headcn": "备注",
                    "IsNotNull": false,
                    "align": null
                }
            ];
            let str = JSON.stringify(datap)
            str = str.replace('"', '').replace('"', '')
            let arr = str.split("\\r\\n")
            console.log('arr' + arr)
            for (let i = 0; i < arr.length - 1; i++) {
                if (arr[i].split('\\t').length == 2) {
                    that.datajson = [...that.datajson, {
                        part_code: arr[i].split('\\t')[0],
                        part_version:'',
                        qty: arr[i].split('\\t')[1],
						remark:'',
                    }]
                }
            }
        }
	}
};
</script>

<style lang="scss" scoped>
span.label-fade-enter {
	font-size: medium;
	margin-right: 20px;
}
</style>
